import React, { useEffect, useState } from 'react';
import { listSupervisedBanks } from '../api/supervisor';
import './LotterySearchModal.css';

// Variante superviseur (2026-09-17) de BankSearchModal.jsx — meme UI/UX exacte
// (recherche par nom, table cliquable) mais restreinte a SES banks
// (listSupervisedBanks(), deja scope Supervisor.covered_banks()) au lieu de la
// recherche company-wide (searchBanks).
const SupervisorBankSearchModal = ({ onSelect, onClose }) => {
  const [query, setQuery] = useState('');
  const [allBanks, setAllBanks] = useState([]);
  const [results, setResults] = useState([]);

  useEffect(() => {
    let cancelled = false;
    listSupervisedBanks()
      .then((data) => {
        if (cancelled) return;
        setAllBanks(data);
        setResults(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleSearch = () => {
    setResults(
      allBanks.filter((b) => b.name.toLowerCase().includes(query.toLowerCase()))
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="lsm-overlay">
      <div className="lsm-modal">
        <div className="lsm-header">
          <button className="lsm-close-btn" onClick={onClose}></button>
        </div>

        <div className="lsm-body">
          <p className="lsm-search-by">Search By:</p>
          <div className="lsm-radio-row">
            <label className="lsm-radio-label">
              <input type="radio" name="searchBy" defaultChecked readOnly />
              Name
            </label>
            <input
              className="lsm-name-input"
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>

          <div className="lsm-search-row">
            <input
              className="lsm-search-input"
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button className="lsm-search-btn" onClick={handleSearch}>Search</button>
          </div>

          <div className="lsm-table-wrapper">
            <table className="lsm-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Nom</th>
                </tr>
              </thead>
              <tbody>
                {results.map((row) => (
                  <tr
                    key={row.id}
                    className="lsm-row"
                    onClick={() => { onSelect(row.id, row.name, row.username, row.seq); onClose(); }}
                  >
                    <td>{row.seq ?? '—'}</td>
                    <td>{row.username || '—'}</td>
                    <td>{row.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="lsm-footer">
          <button className="lsm-cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default SupervisorBankSearchModal;
